(function () {
    'use strict';
    var controllerId = 'stampaCV';
    angular.module('app').controller(controllerId, ['$scope', '$uibModalInstance', '$filter', 'datacontext', 'common', '_', 'dipendente', stampaCVFn]);

    function stampaCVFn($scope, $uibModalInstance, $filter, datacontext, common, _, dipendente) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');

        $scope.item = {};
        $scope.item.Signature = true;
        $scope.item.Attach = false;
        $scope.item.Logo = true;
        $scope.item.Address = true;
        $scope.item.BusinessPhone = true;
        $scope.item.MobilePhone = true;
        $scope.item.DataStampa = getDate();

        if (dipendente.Rev)
            $scope.item.Rev = dipendente.Rev;
        else
            $scope.item.Rev;
        if (dipendente.DataRev)
            $scope.item.DataRev = new Date(dipendente.DataRev);
        else
            $scope.item.DataRev;

        //datapicker
        $scope.open = function ($event, i) {
            $event.preventDefault();
            $event.stopPropagation();

            if (i == 1) {
                $scope.opened = !$scope.opened;
                $scope.opened2 = false;
            }
            else if (i == 2) {
                $scope.opened2 = !$scope.opened2;
                $scope.opened = false;
            }
            
        };

        $scope.dateOptions = {
            formatYear: 'yy',
            startingDay: 1
        };

        $scope.format = 'dd/MM/yyyy';

        $scope.ok = function (isValid) {
            if (isValid) {
                if ($scope.item) {
                    $scope.item.DataStampa = moment($scope.item.DataStampa).format('DD/MM/YYYY');
                    if ($scope.item.DataRev)
                        $scope.item.DataRev = moment($scope.item.DataRev).format('DD/MM/YYYY');
                    $uibModalInstance.close($scope.item);
                }
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        function getDate() {
            return datacontext.timeSheet_getDate().then(function (data) {
                return $scope.item.DataStampa = new Date(data);
            });
        }

        $scope.clearRev = function () {
            if ($scope.item.Rev == null)
                $scope.item.Rev = undefined;
            if ($scope.item.DataRev == null)
                $scope.item.DataRev = undefined;
        };
    }
})();